import React from 'react'
import styled from 'styled-components'

import { Icon, Inline, Stack, Text } from '@procsea/design-system'

import { useUser } from 'src/contexts/userContext'

const RestrictedWidthStack = styled(Stack)`
  min-width: 0;
`

const AccountContextMenuMenuEntry = () => {
  const user = useUser()

  return (
    <Inline spacing="small" alignment="center" noWrap>
      <Icon name="circle-user" size="2x" faStyle="fas" variant="foreground" />
      <RestrictedWidthStack>
        <Text data-e2e="menu-entry-account-username" ellipsis variant="black">
          {user?.fullName}
        </Text>
        <Text data-e2e="menu-entry-account-email" ellipsis variant="foreground" size="small">
          {user?.email}
        </Text>
      </RestrictedWidthStack>
    </Inline>
  )
}

export default AccountContextMenuMenuEntry
